import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	() => ({
		sortableHelper: {
			opacity: 1,
			zIndex: 1000,
			pointerEvents: 'all',

			'& .drag-handle': {
				opacity: '1 !important',
			},
		},
		dragging: {
			pointerEvents: 'none',
		},
	}),
	{ name: 'Questions-AnswerTypes-ImageButtons' },
)

export default useStyles
